import { createContext, useContext, useEffect, useState } from "react";
import ApiServices from "../../../service/ApiServices";

const UserContext = createContext();

const res = new ApiServices();

export const UserProvider = ({children}) => {
    const storageUser = JSON.parse(localStorage.getItem('customer'));

    const [customer, setСustomer] = useState(storageUser || {
        name: null,
        phone: null,
        address: null,
    });

    const [userLikes, setLikes] = useState([]);

    useEffect(() => {
        res.getLikes(customer.phone)
        .then(data => {
            setLikes(data)})
        .catch(setLikes([]));
    }, [])

    const thisСustomer = {setСustomer, customer, userLikes}

    return (
        <UserContext.Provider value={thisСustomer}>
            {children}
        </UserContext.Provider>
    )
}

export const useUser = () => {
    return useContext(UserContext);
}